import React from 'react'
import ProductPageContainer from '../../../../Components/Applications/ECommerce/ProductPage'

export default function ProductPage() {
    return (
        <div className='page-body'>
            <ProductPageContainer />
        </div>
    )
}
